import NiceModal, { useModal } from "@ebay/nice-modal-react";
import cx from "classnames";
import { useState } from "react";
import { canv } from "@/canv/global";
import { Button } from "@/shared/ui/Button";
import styles from "./RenameBoardModal.module.scss";

type RenameBoardModalProps = {
    boardName: string;
};

export const RenameBoardModal = NiceModal.create<RenameBoardModalProps>(({ boardName }) => {
    const modal = useModal();
    const [name, setName] = useState(boardName);

    const handleSubmit = () => {
        modal.resolve(name.trim());
        modal.remove();
    };

    const handleCancel = () => {
        modal.remove();
    };

    const handleChange = (e) => setName(e.target.value);
    const handleKeyDown = (e) => {
        if (e.key === "Enter") handleSubmit();
    };
    const handleFocus = () => {
        canv.appInterface.inputFocused = 1;
    };
    const handleBlur = () => {
        canv.appInterface.inputFocused = 0;
    };

    return (
        <div className={styles.renameWindowWrapper} onClick={handleCancel}>
            <div className={styles.renameWindow} onClick={(e) => e.stopPropagation()}>
                <div className={styles.renameWindowAbout}>Название доски</div>

                <div className={styles.renameWindowName}>
                    <div className={styles.renameWindowNameWrapper}>
                        <input
                            className={styles.renameWindowNameWrapperField}
                            type="text"
                            placeholder="Ваша доска"
                            value={name}
                            onChange={handleChange}
                            onKeyDown={handleKeyDown}
                            onFocus={handleFocus}
                            onBlur={handleBlur}
                        />
                    </div>
                </div>

                <div className={styles.renameWindowDescription}>
                    Выбирайте короткие и запоминающиеся названия.
                    <br />
                    Так будет проще найти нужную доску.
                </div>

                <div className={styles.renameWindowActions}>
                    <Button className={styles.renameWindowActionsItem} onClick={handleSubmit}>
                        Готово
                    </Button>

                    <Button
                        className={cx(
                            styles.renameWindowActionsItem,
                            styles.renameWindowActionsItemBack,
                        )}
                        variant="tertriary"
                        onClick={handleCancel}
                    >
                        Отмена
                    </Button>
                </div>
            </div>
        </div>
    );
});
